/**
 * Constants definition.
 *
 * @type {{BANk_DEPOSIT_ACCOUNT_OPEN: string, BANk_CAPITAL_DEPOSIT: string, ONAT_VERIFICATION: string, BANk_CREDIT_ACCOUNT_OPEN: string}}
 */
const PROCESS_IDENTIFIERS = {
  BANK_DEPOSIT_ACCOUNT_OPEN: '804aa04b75eb2c5160fa7b63',
  BANK_CAPITAL_DEPOSIT: '604aa04b75eb2c5160fa7b61',
  ONAT_VERIFICATION: '704aa04b75eb2c5160fa7b62',
  BANK_CREDIT_ACCOUNT_OPEN: '504aa04b75eb2c5160fa7b60',
  COMMERCIAL_REGISTER: '61522a47ccbe2e0042a6d173',
  NOTARY_REGISTER: '615cb26f6fac3b65079cdccd',
  COMPANY_CREATED: '884aa04b75eb2c5160fa7cf5',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const PROCESS_IDENTIFIERS_ENUM = Object.keys(PROCESS_IDENTIFIERS);
const PROCESS_IDENTIFIERS_IDS_ENUM = Object.values(PROCESS_IDENTIFIERS);

const BANK_DEPOSIT_ACCOUNT_OPEN = PROCESS_IDENTIFIERS_IDS_ENUM[0];
const BANK_CAPITAL_DEPOSIT = PROCESS_IDENTIFIERS_IDS_ENUM[1];
const ONAT_VERIFICATION = PROCESS_IDENTIFIERS_IDS_ENUM[2];
const BANK_CREDIT_ACCOUNT_OPEN = PROCESS_IDENTIFIERS_IDS_ENUM[3];
const COMPANY_CREATED = PROCESS_IDENTIFIERS_IDS_ENUM[6];

export {
  PROCESS_IDENTIFIERS,
  PROCESS_IDENTIFIERS_IDS_ENUM,
  PROCESS_IDENTIFIERS_ENUM,
  BANK_CREDIT_ACCOUNT_OPEN,
  BANK_CAPITAL_DEPOSIT,
  ONAT_VERIFICATION,
  BANK_DEPOSIT_ACCOUNT_OPEN,
  COMPANY_CREATED,
};
